import { useState } from 'react';
import { Button, Container, Group, Loader, Select, Title } from '@mantine/core';
import { IUserAccount } from '../../../../libs/api-client';
import { useIntlLight } from '../../../../libs/i18n';
import { useImpersonation } from '../../../../services/auth';
import useAuth from '../../../../hooks/useAuth';

export default function ImpersonationModal({ onClose }: { onClose: () => void }) {
  const { t } = useIntlLight();
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const { enterImpersonation } = useAuth();
  const { impersonationUsers } = useImpersonation();

  if (!impersonationUsers) return <Loader />;

  const userOptions =
    impersonationUsers
      ?.filter(u => !!u.email)
      .map(u => ({
        value: u.email,
        label: u.email,
      })) ?? [];

  return (
    <Container size="sm">
      <Title size={20} align="center">
        {t('auth.selectEmail')}
      </Title>
      <Group mt="md">
        <Select
          style={{ flex: 1 }}
          placeholder={t('auth.selectEmail')}
          value={selectedEmail}
          onChange={setSelectedEmail}
          data={userOptions}
          searchable
          clearable
        />
      </Group>
      <Group position="right" mt="md">
        <Button
          disabled={!selectedEmail}
          onClick={() => {
            if (selectedEmail) {
              enterImpersonation(selectedEmail);
            }
            onClose();
          }}
        >
          {t('auth.impersonate')}
        </Button>
      </Group>
    </Container>
  );
}
